import {
  Debouncer,
  AddressSuggesterService,
  BasicAddressDetails,
  SuggestedAddress,
} from '@insurgrid/common';
import { useEffect, useMemo, useState } from 'react';
import {
  SearchableDropdownProps,
  SearchableDropdownItem,
} from '../SearchableDropdown';
import { FormSearchableDropdown } from './FormSearchableDropdown';

export function AddressInput(
  props: {
    name: string;
    onAddress?: (address: BasicAddressDetails) => void;
    label: string;
    value?: string;
    defaultValue?: string;
  } & SearchableDropdownProps,
) {
  const [search, setSearch] = useState<string>('');
  const [results, setResults] = useState<SuggestedAddress[]>([]);
  const [loading, setLoading] = useState(false);

  const options = results.map((address) => {
    return {
      label: address.label,
      value: address.label,
    };
  });

  const onChange = async (option: SearchableDropdownItem) => {
    const id = results.find((a) => a.label === option.label)?.id;
    if (!id) {
      return;
    }

    const address = await AddressSuggesterService.getFullAddress(id);
    if (!address) {
      return;
    }

    props.onAddress?.(address);
  };

  const debouncer = useMemo(
    () =>
      new Debouncer<string>((val, signal) => {
        setLoading(true);
        AddressSuggesterService.getSuggestedAddresses(val).then((addresses) => {
          if (!addresses) {
            return;
          }
          setResults(addresses);
          setLoading(false);
        });
      }, 300),
    [setResults],
  );

  useEffect(() => {
    if (search) {
      debouncer.emit(search);
    } else {
      setResults([]);
    }
  }, [search]);

  return (
    <FormSearchableDropdown
      name={props.name}
      defaultValue={props.defaultValue}
      label={props.label}
      filteredItems={options}
      items={options ?? []}
      setSearch={setSearch}
      search={search}
      onChange={async (item: any) => {
        await onChange(item);
      }}
      displayValueFunction={(item) => {
        if (props.value) {
          return props.value;
        }
        if (item) {
          return item instanceof Array ? item[0].value : item.value;
        }
        if (props.defaultValue) {
          return props.defaultValue;
        }
        return search;
      }}
      inputClassName="mb-1"
      resultsLoading={loading}
      dropdownStyles={{ minWidth: 'auto' }}
      data-test-id={props['data-test-id']}
    />
  );
}
